// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* conteneur englobant l'ensemble des informations */
table{
    border-collapse:collapse;
}
tr>td {
  padding: 5px;
}
table,
tr,
td,
div {
    page-break-inside: avoid;
}
.EtiquetteChaussures{
	width: 25cm;
  height: 3.5cm;
  border: solid 0.1px;

}
.logoP2BouPromoChaussuresPromo {
           background-color: #e8182e;
    color: #fff;
    border-radius: 50px;
    font-size: 11px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40%;
    height: 25px;
}
.dlpro-manufacturer-name-custom{
	font-size: 10px;
    width: 100%;
}
.logoP2BouPromoChaussuresPrixDebad{
	   display: flex;
    justify-content: center;
      align-items: end;
}
.logoP2BouPromoChaussuresPrixDebad span {
    font-size: 14px;
    margin-right: 2px;
    line-height: 16px;
}
.logoP2BouPromoChaussuresPrixDebad img {
    width: 25%;
}
.PVCChaussuresPriceValue{
	    text-decoration: line-through;
}
.EtiquetteChaussuresSize{
	width: 25cm;
  height: 3.5cm;
}
.no-margin-print{margin-top: 20px;}
.no-margin-top-left{
	margin-top: 20px;
	margin-left: 25px;
}
.no-padding-print{
	padding-left: 90px !important;
}
.chaussuresCheckGreen {
       position: absolute;
    top: 5px;
    left: 5px;
}
.chaussuresCheckGreen img{
    width: 20px;
} 
.logoFabricantChaussures {
         position: absolute;
    top: 5px;
    left: 50%;
    transform: translateX(-50%);
}
.logoFabricantChaussures img {
    height: 30px;
}
.bigSizeEtiquetteChaussures {
       color: red;
    font-size: 22px;
    font-weight: 600;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    line-height: 28px;
}
.etiquetteDailyMailing .EtiquetteChaussures{
	    
}
.conteneurEtiquetteChaussures {
  display: block;
  width: 25cm;
  height: 3.5cm;
}

/* conteneur représentant la partie gauche de l'étiquette (logo, ref, caractéristiques) */
.conteneurCaracteristiquesChaussures {
  width: 75%;
  float: left;
  position: relative;
  height: 100%;
}





.logoFabricantChaussures img + img {
  height: 30px;
}



.smallSizeEtiquetteChaussures {
  height: 63.12px;
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
}

.caracteristiquesProduitChaussures {
      color: black;
    font-weight: 600;
    position: absolute;
    bottom: 5px;
    text-align: center;
    width: 100%;
}

/* conteneur représentant la partie droite de l'étiquette (PVC, logo P2B ou Promo, PV) */

.conteneurPrixChaussures {
	width: 25%;
	float: left;
	height: 100%;
	overflow: hidden;
	    position: relative;
}

.PVCChaussures {
     color: #000;
    display: flex;
    flex-direction: column;
    font-size: 12px;
    text-decoration: line-through;
    background: #ffff;
    position: relative;
	    margin-top: 10px;
		    margin-right: 2px;
}

.PVCChaussuresPrice{
	     position: absolute;
    top: 5px;
    right: 0;
    text-align: center;
    width: 100%;
    font-size: 20px;
}

.PVCChaussuresPriceName{
	margin-right: 10px;
}

.logoP2BouPromoChaussures {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
         margin: 6px 0 3px;
}

.PVChaussures {
    color: white;
    display: flex;
    flex-direction: column;
    font-size: 22px;
    font-weight: 600;
	    position: relative;
		 margin-right: 2px;
}
.PVChaussuresPrice{
	     position: absolute;
    top: 0;
    right: 0;
    text-align: center;
    width: 100%;
    font-size: 28px;
}
@media print {
	.no-print{
		display: none !important;
	}
  table { page-break-after:auto }
  table tr    { page-break-inside:avoid; page-break-after:auto }
  table thead { display:table-header-group }
  table tfoot { display:table-footer-group }
  .page-break  { display: block; page-break-before: always; }
  .no-padding-print{ padding-left: 0 !important}
  .no-margin-print{margin-top: 0;}
  .no-margin-top-left{ margin-top: 0; margin-left: 0;}
 }
 @media screen and (max-width: 50em) {
  .Logo2bad-login{
	width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/EtiquetteChaussures.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;IACI,wBAAwB;AAC5B;AACA;EACE,YAAY;AACd;AACA;;;;IAII,wBAAwB;AAC5B;AACA;CACC,WAAW;EACV,aAAa;EACb,mBAAmB;;AAErB;AACA;WACW,yBAAyB;IAChC,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,YAAY;AAChB;AACA;CACC,eAAe;IACZ,WAAW;AACf;AACA;IACI,aAAa;IACb,uBAAuB;MACrB,gBAAgB;AACtB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,UAAU;AACd;AACA;KACK,6BAA6B;AAClC;AACA;CACC,WAAW;EACV,aAAa;AACf;AACA,iBAAiB,gBAAgB,CAAC;AAClC;CACC,gBAAgB;CAChB,iBAAiB;AAClB;AACA;CACC,6BAA6B;AAC9B;AACA;OACO,kBAAkB;IACrB,QAAQ;IACR,SAAS;AACb;AACA;IACI,WAAW;AACf;AACA;SACS,kBAAkB;IACvB,QAAQ;IACR,SAAS;IACT,2BAA2B;AAC/B;AACA;IACI,YAAY;AAChB;AACA;OACO,UAAU;IACb,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,UAAU;IACV,iBAAiB;AACrB;AACA;;AAEA;AACA;EACE,cAAc;EACd,WAAW;EACX,aAAa;AACf;;AAEA,yFAAyF;AACzF;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;;;;;AAMA;EACE,YAAY;AACd;;;;AAIA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;MACM,YAAY;IACd,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf;;AAEA,wFAAwF;;AAExF;CACC,UAAU;CACV,WAAW;CACX,YAAY;CACZ,gBAAgB;KACZ,kBAAkB;AACvB;;AAEA;KACK,WAAW;IACZ,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;KACjB,gBAAgB;MACf,iBAAiB;AACvB;;AAEA;MACM,kBAAkB;IACpB,QAAQ;IACR,QAAQ;IACR,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;SACZ,iBAAiB;AAC1B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gBAAgB;KACf,kBAAkB;GACpB,iBAAiB;AACpB;AACA;MACM,kBAAkB;IACpB,MAAM;IACN,QAAQ;IACR,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;AACA;CACC;EACC,wBAAwB;CACzB;EACC,QAAQ,sBAAsB;EAC9B,cAAc,uBAAuB,EAAE,sBAAsB;EAC7D,cAAc,2BAA2B;EACzC,cAAc,2BAA2B;EACzC,eAAe,cAAc,EAAE,yBAAyB,EAAE;EAC1D,mBAAmB,0BAA0B;EAC7C,iBAAiB,aAAa,CAAC;EAC/B,qBAAqB,aAAa,EAAE,cAAc,CAAC;CACpD;CACA;EACC;CACD,WAAW;EACV;AACF","sourcesContent":["/* conteneur englobant l'ensemble des informations */\ntable{\n    border-collapse:collapse;\n}\ntr>td {\n  padding: 5px;\n}\ntable,\ntr,\ntd,\ndiv {\n    page-break-inside: avoid;\n}\n.EtiquetteChaussures{\n\twidth: 25cm;\n  height: 3.5cm;\n  border: solid 0.1px;\n\n}\n.logoP2BouPromoChaussuresPromo {\n           background-color: #e8182e;\n    color: #fff;\n    border-radius: 50px;\n    font-size: 11px;\n    font-weight: bold;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 40%;\n    height: 25px;\n}\n.dlpro-manufacturer-name-custom{\n\tfont-size: 10px;\n    width: 100%;\n}\n.logoP2BouPromoChaussuresPrixDebad{\n\t   display: flex;\n    justify-content: center;\n      align-items: end;\n}\n.logoP2BouPromoChaussuresPrixDebad span {\n    font-size: 14px;\n    margin-right: 2px;\n    line-height: 16px;\n}\n.logoP2BouPromoChaussuresPrixDebad img {\n    width: 25%;\n}\n.PVCChaussuresPriceValue{\n\t    text-decoration: line-through;\n}\n.EtiquetteChaussuresSize{\n\twidth: 25cm;\n  height: 3.5cm;\n}\n.no-margin-print{margin-top: 20px;}\n.no-margin-top-left{\n\tmargin-top: 20px;\n\tmargin-left: 25px;\n}\n.no-padding-print{\n\tpadding-left: 90px !important;\n}\n.chaussuresCheckGreen {\n       position: absolute;\n    top: 5px;\n    left: 5px;\n}\n.chaussuresCheckGreen img{\n    width: 20px;\n} \n.logoFabricantChaussures {\n         position: absolute;\n    top: 5px;\n    left: 50%;\n    transform: translateX(-50%);\n}\n.logoFabricantChaussures img {\n    height: 30px;\n}\n.bigSizeEtiquetteChaussures {\n       color: red;\n    font-size: 22px;\n    font-weight: 600;\n    text-align: center;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 90%;\n    line-height: 28px;\n}\n.etiquetteDailyMailing .EtiquetteChaussures{\n\t    \n}\n.conteneurEtiquetteChaussures {\n  display: block;\n  width: 25cm;\n  height: 3.5cm;\n}\n\n/* conteneur représentant la partie gauche de l'étiquette (logo, ref, caractéristiques) */\n.conteneurCaracteristiquesChaussures {\n  width: 75%;\n  float: left;\n  position: relative;\n  height: 100%;\n}\n\n\n\n\n\n.logoFabricantChaussures img + img {\n  height: 30px;\n}\n\n\n\n.smallSizeEtiquetteChaussures {\n  height: 63.12px;\n  color: black;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.caracteristiquesProduitChaussures {\n      color: black;\n    font-weight: 600;\n    position: absolute;\n    bottom: 5px;\n    text-align: center;\n    width: 100%;\n}\n\n/* conteneur représentant la partie droite de l'étiquette (PVC, logo P2B ou Promo, PV) */\n\n.conteneurPrixChaussures {\n\twidth: 25%;\n\tfloat: left;\n\theight: 100%;\n\toverflow: hidden;\n\t    position: relative;\n}\n\n.PVCChaussures {\n     color: #000;\n    display: flex;\n    flex-direction: column;\n    font-size: 12px;\n    text-decoration: line-through;\n    background: #ffff;\n    position: relative;\n\t    margin-top: 10px;\n\t\t    margin-right: 2px;\n}\n\n.PVCChaussuresPrice{\n\t     position: absolute;\n    top: 5px;\n    right: 0;\n    text-align: center;\n    width: 100%;\n    font-size: 20px;\n}\n\n.PVCChaussuresPriceName{\n\tmargin-right: 10px;\n}\n\n.logoP2BouPromoChaussures {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n         margin: 6px 0 3px;\n}\n\n.PVChaussures {\n    color: white;\n    display: flex;\n    flex-direction: column;\n    font-size: 22px;\n    font-weight: 600;\n\t    position: relative;\n\t\t margin-right: 2px;\n}\n.PVChaussuresPrice{\n\t     position: absolute;\n    top: 0;\n    right: 0;\n    text-align: center;\n    width: 100%;\n    font-size: 28px;\n}\n@media print {\n\t.no-print{\n\t\tdisplay: none !important;\n\t}\n  table { page-break-after:auto }\n  table tr    { page-break-inside:avoid; page-break-after:auto }\n  table thead { display:table-header-group }\n  table tfoot { display:table-footer-group }\n  .page-break  { display: block; page-break-before: always; }\n  .no-padding-print{ padding-left: 0 !important}\n  .no-margin-print{margin-top: 0;}\n  .no-margin-top-left{ margin-top: 0; margin-left: 0;}\n }\n @media screen and (max-width: 50em) {\n  .Logo2bad-login{\n\twidth: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
